import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import cloneDeep from 'lodash/cloneDeep';
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { ItemsService } from "../../../../services/items.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "scaffold-template-data-array",
  templateUrl: "./template-data-array.component.html",
  styleUrls: [
    "../../rendered.component.scss",
    "./template-data-array.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateDataArrayComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  prefix;
  keys = [];
  data_items = {};
  view_array = [];
  data_array = [];
  last_keys = [];
  watch_value;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private itemsService: ItemsService
  ) {
    super(cdr, renderedService);
  }

  getAtIndex(key) {
    if (!this.data_items[key]) this.data_items[key] = {};
    this.data_items[key][this.item.index_key] = key;
    return this.data_items[key];
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
    console.log(JSON.stringify(this.item, null, 2));
    if (this.item.datas) {
      this.item.datas.forEach((val) => {
        console.log(val);
        this.data_items[val[this.item.index_key]] = val;
      });
    }
    this.view_array = this.item.items;
    console.log(this.data_items);
    this.itemsService
      .registerItem(this.info)
      .pipe(takeUntil(this.destroy$))
      .subscribe((d) => {
        console.log("subscription");
        if (d.hasOwnProperty(this.item.name)) {
          console.log(
            "updating " + this.item.name + " to ",
            d[this.item.name],
            ":" + this.item.type + " - " + this.item.out_name
          );
          try {
            let val = this.itemsService.get(
              d,
              (this.prefix ? this.prefix : "") + this.item.name
            );
            console.log(val);
            if (val.forEach) {
              val.forEach((i) => {
                if (i.hasOwnProperty(this.item.index_key)) {
                  this.data_array.forEach((data) => {
                    if (data[this.item.index_key] == i[this.item.index_key]) {
                      Object.keys(i).forEach((key) => {
                        data[key] = i[key];
                      });
                    }
                  });
                }
              });
            }
            this.update();
          } catch (e) {
            console.log(e);
          }
        }
        if (d.hasOwnProperty(this.item.out_name)) {
          let value = d[this.item.out_name];
          if (this.watch_value != value) {
            this.watch_value = value;
            let keys = value.match(/\[[^\]]+\]/g);
            console.log(keys);
            if (JSON.stringify(this.last_keys) != JSON.stringify(keys)) {
              //prevent calculating the new tempate keys if they havent changes when the text is updated
              this.last_keys = keys;
              this.view_array = [];
              this.data_array = [];
              if (keys) {
                keys.forEach((k, i) => {
                  let key = k.replace(/[\[,\]]/g, "");
                  this.data_array.push(this.getAtIndex(key));
                  this.view_array.push(cloneDeep(this.item.content));
                });

                console.log(this);
                console.log(
                  "updating",
                  (this.prefix ? this.prefix : "") + this.item.name,
                  this.data_array
                );
                this.itemsService.updateValue(
                  (this.prefix ? this.prefix : "") + this.item.name,
                  this.data_array,
                  this.info
                );
                console.log(this.itemsService.getData(this.info));
                this.update();
              }
            }
          }
        }
      });
    console.log(this.item.name, this.item.paramprefix);
    this.prefix = "";
    if (this.item.paramprefix && this.item.paramprefix.length)
      this.prefix += this.item.paramprefix + "/";
    console.log(this.prefix);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
